import { render } from "./RevuePage.vue?vue&type=template&id=f6973a1e"
import script from "./RevuePage.vue?vue&type=script&lang=js"
export * from "./RevuePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__